import {
    GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF,
    GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_SUCCESS,
    RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_API_ERROR
} from "./actionTypes"

export const getRavenAuthorizationResponseCodeDefList = () => ({
    type: GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF,
})

export const getRavenAuthorizationResponseCodeDefListSuccess = record => ({
    type: GET_RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_SUCCESS,
    payload: record,
})

export const ravenAuthorizationResponseCodeDefApiError = error => {
    return {
        type: RAVEN_AUTHORIZATION_RESPONSE_CODE_DEF_API_ERROR,
        payload: error,
    }
}
